import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import SubAreaService from "@services/SubAreaService";

const ShowSubArea = ({ subArea }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [subAreaData, setSubAreaData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
    setSubAreaData([]);
  };
  useEffect(() => {
    if (showModal)
      SubAreaService.find(subArea.id).then((response) => {
        setSubAreaData(response.data.data);
      });
  }, [subArea.id, showModal]);

  return (
    <PermissionHandler permission={"view_sub_areas"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={subAreaData.name} />
          <RowDetails label={t("nameEng")} value={subAreaData.name_eng} />
          <RowDetails
            label={t("description")}
            value={subAreaData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowSubArea;
